import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface CreateCompareInput {
    chatId: string;
    sourceToolCallId: string;
    curatedExternalIds: string[];
}

interface CreateCompareResult {
    experimentId: string;
    optionA: { text: string };
    optionB: { text: string };
}

export function useCreateGoogleDriveCompareMutation() {
    return useMutation({
        mutationFn: async (input: CreateCompareInput): Promise<CreateCompareResult> => {
            const res = await apiClient.createGoogleDriveCompare({
                params: { chatId: input.chatId },
                body: {
                    sourceToolCallId: input.sourceToolCallId,
                    curatedExternalIds: input.curatedExternalIds,
                },
            });

            if (res.status !== 200) {
                throw new Error("Failed to create Google Drive comparison");
            }

            return {
                experimentId: res.body.experimentId,
                optionA: res.body.optionA,
                optionB: res.body.optionB,
            };
        },
    });
}
